import { FamilySubscription } from "@/types/subscription";

export const calculateDaysInfo = (subscription: FamilySubscription | null) => {
  if (!subscription) return null;

  const startDate = new Date(subscription.startDate);
  const endDate = new Date(subscription.endDate);
  const today = new Date();

  const totalDays = Math.ceil(
    (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
  );
  const daysElapsed = Math.ceil(
    (today.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
  );

  return {
    current: Math.max(1, Math.min(daysElapsed, totalDays)),
    total: totalDays,
  };
};

export const handleFaqToggle = (
  isFaqOpen: boolean,
  setIsFaqOpen: (value: boolean) => void,
  setOpenFaqIndex: (value: number | null) => void
) => {
  setIsFaqOpen(!isFaqOpen);
  if (!isFaqOpen) {
    setOpenFaqIndex(null);
  }
};

export const handleFaqItemToggle = (
  index: number,
  openFaqIndex: number | null,
  setOpenFaqIndex: (value: number | null) => void
) => {
  setOpenFaqIndex(openFaqIndex === index ? null : index);
};
